import { TalentInformationProps } from "./types";
import { PersonalInformationCard } from "./TalentInformation/PersonalInformationCard";
import { AddressContactCard } from "./TalentInformation/AddressContactCard";
import { EducationLanguageCard } from "./TalentInformation/EducationLanguageCard";
import { OtherDetailsCard } from "./TalentInformation/OtherDetailsCard";

export function TalentInformation({ profile }: TalentInformationProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <PersonalInformationCard profile={profile} />
      <AddressContactCard profile={profile} />
      <EducationLanguageCard profile={profile} />
      <OtherDetailsCard profile={profile} />
    </div>
  );
}
